module.exports = __webpack_public_path__ + "img/account-summary-pricing.065176cd.svg";